import React from "react";
import "../../css/components/loaders/LoadingSpinner.css";

const LoadingSpinner = () => {
    return (
        <div className="loading-overlay">
            <div id="ui">
                <div className="dice child">
                    <ol className="dice_list">
                        <li className="dice_list_item"></li>
                        <li className="dice_list_item"></li>
                        <li className="dice_list_item"></li>
                        <li className="dice_list_item"></li>
                        <li className="dice_list_item"></li>
                        <li className="dice_list_item"></li>
                    </ol>
                </div>
            </div>
        </div>
    );
}

export default LoadingSpinner;
